module.exports = __webpack_public_path__ + "media/images/pic/lectors/nicola-agier-a207808ece4174524dbe3c52a1160240.jpeg";